import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";

export const ForcePasswordChange = () => {
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const save = async () => {
    if (f.next !== f.again) { toast.error("The new passwords don't match"); return; }
    try { await api.post("/auth/me/password", { current_password: f.current, new_password: f.next }); toast.success("Password changed"); window.location.reload(); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  const row = (k, label) => (
    <div className="space-y-1"><Label>{label}</Label><Input type="password" value={f[k]} onChange={(e) => setF((x) => ({ ...x, [k]: e.target.value }))} data-testid={`force-pw-${k}`} /></div>
  );
  return (
    <div className="mx-auto max-w-md pt-10" data-testid="force-password-change">
      <Card><CardHeader><CardTitle className="flex items-center gap-2 text-lg"><KeyRound className="h-5 w-5 text-primary" />Change your password</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-muted-foreground">Your administrator asked you to choose a new password before you continue.</p>
          {row("current", "Current password")}{row("next", "New password")}{row("again", "New password again")}
          <Button className="w-full" disabled={!f.current || f.next.length < 8} onClick={save} data-testid="force-pw-save">Change password</Button>
        </CardContent></Card>
    </div>
  );
};
